{
  "email": "Email",
  "firstName": "First name",
  "lastName": "Last name",
  "password": "Password",
  "back": "Back",
  "signOut": "Sign out",
  "confirm": "Confirm",
  "confirmTitle": "Confirm",
  "cancel": "Cancel",
  "cancelCountdown": "Cancel {{seconds}}s",
  "cancelCountdownShort": "{{seconds}}s",
  "close": "Close",
  "approve": "Approve",
  "save": "Save",
  "saving": "Saving…",
  "generate": "Generate",
  "platformDisabledModel": "Temporarily disabled by the platform",
  "generationPriceHint": "Estimated price",
  "table": {
    "pinColumn": "Pin column",
    "unpinColumn": "Unpin column",
    "openInPeek": "Open in side peek"
  },
  "frameFormat": {
    "vertical": "9:16 — vertical",
    "horizontal": "16:9 — horizontal",
    "square": "1:1 — square",
    "ultrawide": "21:9 — ultrawide",
    "portrait34": "3:4 — vertical",
    "landscape43": "4:3 — horizontal"
  },
  "status": {
    "draft": "Draft",
    "generated": "Generated",
    "in_review": "In review",
    "approved": "Approved",
    "needs_changes": "Needs changes",
    "locked": "Locked",
    "failed": "Error",
    "queued": "Queued",
    "processing": "Running",
    "completed": "Done",
    "cancelled": "Cancelled"
  },
  "referenceInputs": {
    "addFromLibraryPartial": "Could not add: {{names}}",
    "heading": "References for generation",
    "sectionTitle": "References",
    "openPreview": "Open full size",
    "removeReference": "Remove reference",
    "removeConfirm": "Remove this reference for generation?",
    "lightboxTitle": "Reference for generation",
    "addReference": "Add reference",
    "dropOrPasteHint": "Drop files here or paste an image from the clipboard (Ctrl/Cmd+V)",
    "unsupportedFileType": "Unsupported file type",
    "fileTooLarge": "The file is larger than {{max}} MB",
    "videoDurationInvalid": "Video must be between {{min}} and {{max}} seconds",
    "videoDurationUnreadable": "Could not determine video duration",
    "videoDurationTotalInvalid": "Combined video references must be at most {{max}} s (now {{total}} s)",
    "videoDurationBudget": "{{used}} / {{max}} s of video references"
  },
  "imageLightbox": {
    "defaultTitle": "Image preview",
    "noImage": "No image",
    "downloadOriginal": "Download original",
    "copy": "Copy",
    "copyTitle": "Copy original to clipboard",
    "copySuccess": "Original copied to clipboard",
    "copyError": "Could not copy image"
  },
  "voicePicker": {
    "voice": "Voice",
    "characterVoices": "Character voices",
    "librarySection": "{{provider}} library",
    "libraryBadge": "{{provider}} library",
    "defaultVoice": "Default voice",
    "activeMark": "· primary",
    "searchPlaceholder": "Search voices…",
    "searchEmpty": "Nothing found",
    "libraryLoading": "Loading the library…",
    "libraryFailed": "Failed to load the library.",
    "retry": "Retry",
    "playPreview": "Play",
    "pausePreview": "Pause",
    "noVoices": "No voices available: connect an audio provider in Studio settings."
  },
  "voiceDictation": {
    "start": "Dictate prompt",
    "startHold": "Hold to dictate",
    "microphone": "Microphone",
    "microphoneSettings": "Microphone and recording mode",
    "defaultMicrophone": "Default microphone",
    "defaultInputNamed": "Default — {{name}}",
    "microphoneN": "Microphone {{n}}",
    "microphoneUnavailable": "Selected microphone is unavailable — recording from the default input",
    "holdToRecord": "Hold to record",
    "stop": "Stop recording",
    "recording": "Recording",
    "transcribing": "Transcribing",
    "errorPermission": "No microphone access. Allow it in your browser settings.",
    "errorMicUnavailable": "Microphone is unavailable.",
    "errorTooShort": "Recording is too short.",
    "errorNoSpeech": "Could not make out any speech — please try again.",
    "errorUnsupported": "Unsupported recording format.",
    "errorTooLarge": "Recording is too large.",
    "errorInsufficientFunds": "Not enough funds for speech recognition.",
    "errorCompanyArchived": "The company is archived — speech recognition is unavailable.",
    "errorUnavailable": "Speech recognition is currently unavailable.",
    "errorRateLimited": "Too many transcription requests. Please try again later.",
    "errorFailed": "Speech recognition failed."
  },
  "agreementPage": {
    "version": "Version {{version}}",
    "updated": "Updated {{date}}"
  }
}
